<template>
  <div>
    <CRow class="mb-5">
      <CCol md="12" lg="12" sm="12" xs="12" class="float-right">
        <button @click="mtdBack" type="button" class="btn btn-sm text-white float-right" style="background: #E46666">
          <i class="fas fa-hand-point-left"></i> Ir a Inicio
        </button>
      </CCol>
    </CRow>
    <div class="row">
      <div id="div_conte" class="col-md-10 mx-auto">
        <div class="bg-secondary text-white bg-opacity-10">
          <div class="text-center py-4 px-5" id="scroll-div">
            <div v-for="(buttonGroup, index) in groupedButtons" :key="index" class="row">
              <button v-for="(button, idx) in buttonGroup" :key="idx" class="div-button col m-2 p-2 text-white"
                @click="changePage(button.page)">
                {{ button.label }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      buttons: [
        // { label: "ROLES", page: "roles" },
        { label: "SEDES", page: "campus" },
        { label: "CONVENIOS", page: "agreement" },
        { label: "CLIENTE", page: "clients" },
        { label: "ALMACENES", page: "almacen" },
        { label: "CAJAS", page: "boxes" },
        { label: "PERSONAL", page: "personal" },
        { label: "METODO DE PAGO", page: "method_payment" },
        { label: "UNIDADES", page: "units" },
        { label: "INSUMOS", page: "insumos" },
        { label: "CATEGORIAS", page: "categories"},
        { label: "CARTA", page: "products" },
        { label: "PROVEEDORES", page: "provider" },
        // { label: "KITS", page: "kits" },
        // { label: "PROYECTOS", page: "projects" },
        { label: "PISOS", page: "level" },
        { label: "MESAS", page: "tables" },
      ],
    };
  },
  computed: {
    filteredButtons() {
      if (this.isUserAdminHowert) {
        return this.buttons;
      } else {
        return this.buttons.filter(button => button.page === 'clients');
      }
    },
    // Agrupar botones en grupos de 4
    groupedButtons() {
      const groups = [];
      for (let i = 0; i < this.filteredButtons.length; i += 4) {
        groups.push(this.filteredButtons.slice(i, i + 4));
      }
      return groups;
    },
    isUserAdminHowert() {
      return this.$store.getters.get_rol.id == 1;
    },
  },
  methods: {
    changePage(page) {
      this.$emit("changePage", page);
    },
    mtdBack() {
      this.$emit('setView', 'home')
    }
  },
};
</script>
<style scoped>
.btn-custom {
  background: #926cdc;
  border-radius: 15px;
  border: none;
}

#div_conte {
  border: 1.5px solid #926cdc;
  padding: 0;
  margin: 40px 0;
}

.div-button {
  background: #926cdc;
  border-radius: 15px;
  border: none;
}

#scroll-div {
  height: auto;
  overflow-y: scroll;
}

#scroll-div>div>button {
  height: 65px;
}

@media (max-width: 1320px) {
  #div_conte {
    border: 1.5px solid #926cdc;
    padding: 0;
    margin: 60px 0;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {

  #div_conte {
    border: 1.5px solid #926cdc;
    padding: 0;
    margin: 100px 0;
  }

  #scroll-div {
    height: 518px;
  }
}

@media (max-width: 768px) {
  #scroll-div>div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #div_conte2 {
    padding-left: 30px;
    padding-right: 30px;
  }

  #scroll-div>div>button {
    height: 44px;
    width: 100%;
    margin: 5px 0;
  }

  .container {
    font-size: 11px;
  }

  #scroll-div {
    height: 450px;
  }
}

@media (max-width: 415px) {
  #scroll-div>div>button {
    height: 40px;
    font-size: 12px;
  }
}
</style>
